import { CHANGE_REQUEST_ROW_STATUS } from './constants';

/**
 * Normalizes API row status for supervised change-request rows.
 *
 * @param {unknown} status
 * @returns {typeof CHANGE_REQUEST_ROW_STATUS[keyof typeof CHANGE_REQUEST_ROW_STATUS]}
 */
export function normalizeChangeRequestRowStatus(status) {
  if (status == null || status === '') {
    return CHANGE_REQUEST_ROW_STATUS.PENDING;
  }
  const value = String(status).trim().toLowerCase();
  if (value === CHANGE_REQUEST_ROW_STATUS.APPROVED) {
    return CHANGE_REQUEST_ROW_STATUS.APPROVED;
  }
  if (value === CHANGE_REQUEST_ROW_STATUS.REJECTED) {
    return CHANGE_REQUEST_ROW_STATUS.REJECTED;
  }
  return CHANGE_REQUEST_ROW_STATUS.PENDING;
}

export function countPendingChangeRequests(changeRequests) {
  if (!changeRequests?.length) {
    return 0;
  }

  return changeRequests.reduce(
    (acc, row) =>
      normalizeChangeRequestRowStatus(row.status) ===
      CHANGE_REQUEST_ROW_STATUS.PENDING
        ? acc + 1
        : acc,
    0
  );
}
